import type { FC } from "react";
import React from "react";

import { useTranslation } from "react-i18next";

import type { GroupTeamAgeModel } from "shared/types";
import type { EntityAge } from "shared/types/AgeGenderLevelModel";

import { SkeletonBase } from "shared/uikit";

import { renderGender } from "utils/renderGender";
import { getAgeCategoryName, getAgeCategoryYear } from "utils/serviceUtils/helpers";

import Chip from "../Chip";

interface SkeletonProps {
	loading: boolean;
	age?: never;
	gender?: never;
	level?: never;
}

interface Props {
	age?: GroupTeamAgeModel | EntityAge;
	gender?: string;
	level?: string;
	loading?: never;
}

type ChipsProps = Props | SkeletonProps;

// TODO: remove as we have middleTeamContent
const CharacteristicsChips: FC<ChipsProps> = ({ age, gender, level, loading }) => {
	const { t } = useTranslation();

	return (
		<div className="flex items-center text-hint gap-2">
			{loading ? (
				<>
					<SkeletonBase width={120} height={26} fullScale />
					<SkeletonBase width={80} height={26} fullScale />
					<SkeletonBase width={60} height={26} fullScale />
				</>
			) : (
				<>
					{age && (
						<Chip
							text={
								<>
									<span key="highlight" className="highlight">
										{getAgeCategoryName({
											type: age.type,
											value: age.value
										})}
									</span>
									/ {getAgeCategoryYear(age)}
								</>
							}
						/>
					)}
					{gender && <Chip text={renderGender(gender, t)} />}
					{level && <Chip text={level} />}
				</>
			)}
		</div>
	);
};

export default CharacteristicsChips;
